// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1ATZm","amount":"Amount_amount__1exZP","tip":"Amount_tip__uNjpe","tipHeader":"Amount_tipHeader__o6cfG","tipsWrap":"Amount_tipsWrap__2-V_F"};